import { Box } from '../box';
import { styled } from '../../theme';
import { Tokens, name } from './const';

export const ModalLayoutPaper = styled(Box, { name, slot: 'Paper' })(({ theme }) => ({
  margin: '0 !important',
  maxHeight: '100dvh',
  position: 'relative',
  overflowY: 'auto',
  backfaceVisibility: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: Tokens.PaperColor(),
}));
